import {
  AdvancedTableColumn,
  AdvancedTableContentKind,
  AdvancedTableFilterKind,
  AdvancedTableFiltersDef,
} from '../../../components/AdvancedTable'
import {
  AdvancedFormAttributeType,
  AdvancedFormField,
  AdvancedFormFieldBuilder,
  AdvancedFormInputType,
} from '../../../components/AdvancedForm/advancedFormTypes'
import { __ } from '../../../shared/i18n'
import { AdvancedTableRowColumn } from '../../../components'
import { DetailCell } from '../../../api'
import { CAPABILITIES, getActionsTableColumns } from '../../utility/capabilityUtility'

export const ITEM_CONFIGURATION_FILTERS: AdvancedTableFiltersDef = [
  {
    key: 'equalCodes',
    label: __('fields.labels.code'),
    col: 8,
    type: AdvancedTableFilterKind.STRING_LIST,
    column: 'code',
  },
  {
    key: 'description',
    label: 'Description',
    type: AdvancedTableFilterKind.STRING,
    column: 'description',
    col: 8,
  },
  {
    key: 'itemTypeIds',
    label: __('fields.labels.itemType'),
    type: AdvancedTableFilterKind.AUTOCOMPLETE,
    column: 'itemType',
    col: 8,
    autocomplete: {
      endpoint: '/api/v1/itemTypes',
      sort: 'code,asc',
      multiple: true,
    },
  },
  {
    key: 'creationDate',
    label: __('fields.labels.creationDate'),
    type: AdvancedTableFilterKind.DATE_RANGE,
    column: 'creationDate',
    col: 8,
  },
  {
    key: 'lastModifyDate',
    label: __('fields.labels.lastModifyDate'),
    type: AdvancedTableFilterKind.DATE_RANGE,
    column: 'lastModifyDate',
    col: 8,
  },
]

export const ITEM_CONFIGURATION_FIELDS: AdvancedFormField[] = [
  AdvancedFormFieldBuilder.buildAutocomplete('itemType', 'api/v1/itemTypes', 'code'),
  AdvancedFormFieldBuilder.buildText('description'),
  {
    key: 'code',
    type: AdvancedFormInputType.UNIQUE_TEXT,
    label: __('fields.labels.code'),
    placeholder: __('fields.placeholders.code'),
    rules: [{ required: true }],
    onlyCreate: true,
    unique: {
      endpoint: '/api/v1/itemConfigurations',
      parameter: 'equalCodes',
    },
  },
  AdvancedFormFieldBuilder.buildAttribute('details', AdvancedFormAttributeType.IDENTIFIER, true),
]

export const ITEM_CONFIGURATION_COLUMNS: Array<AdvancedTableColumn> = [
  {
    title: __(`fields.labels.code`),
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: __(`fields.labels.description`),
    key: 'description',
    dataIndex: 'description',
    className: 'stw-extra-medium',
  },
  {
    key: 'itemType',
    title: __(`fields.labels.itemType`),
    dataIndex: 'itemType.code',
    render: (text, record) => <>{record.itemType?.code}</>,
    className: 'stw-extra-medium',
  },
  {
    key: 'details',
    title: __(`fields.labels.details`),
    dataIndex: 'details',
    className: 'stw-small',
    type: AdvancedTableContentKind.COUNTER,
  },
  {
    key: 'creationDate',
    title: __(`fields.labels.creationDate`),
    dataIndex: 'creationDate',
    type: AdvancedTableContentKind.DATE_TIME,
  },
  {
    key: 'lastModifyDate',
    title: __(`fields.labels.lastModifyDate`),
    dataIndex: 'lastModifyDate',
    type: AdvancedTableContentKind.DATE_TIME,
  },
  {
    key: 'action',
    className: 'stw-small',
    fixedType: 'right',
    unmanageable: true,
    hidden: false,
    sortable: false,
    render: (text, record) => (
      <AdvancedTableRowColumn
        actions={getActionsTableColumns(
          record.id,
          '/configuration/settings/itemConfigurations',
          CAPABILITIES.RESOURCE_ENUMERATION_TYPE_EDIT
        )}
      />
    ),
  },
]

export const ITEM_CONFIGURATIONS_DATA: DetailCell[] = [
  { title: 'id', attribute: 'id', columns: 24 },
  { title: 'code', attribute: 'code', columns: 12 },
  { title: 'description', attribute: 'description', columns: 12 },
  { title: 'Item type', attribute: 'itemType.code', columns: 12 },
  { title: 'Creation date', attribute: 'creationDate', type: 'date', columns: 12 },
  { title: 'Last modify date', attribute: 'lastModifyDate', type: 'date', columns: 12 },
]

export const ITEM_CONFIGURATION_DETAILS_COLUMN: Array<AdvancedTableColumn> = [
  {
    title: __(`fields.labels.identifierType`),
    dataIndex: 'identifierType',
    key: 'identifierType',
  },
  {
    title: __(`fields.labels.role`),
    key: 'role',
    dataIndex: 'role',
  },
  {
    title: __(`fields.labels.regex`),
    key: 'regexFilter',
    dataIndex: 'regexFilter',
  },
  {
    title: __(`fields.labels.optional`),
    key: 'optional',
    dataIndex: 'optional',
    type: AdvancedTableContentKind.BOOLEAN,
  },
]
